import { useTranslation } from "react-i18next";
import React from 'react';
import CookieConsent from 'react-cookie-consent';
import { connect } from 'react-redux';
import { acceptCookieConsent } from 'store/slices/settingsSlice';

const CookieConsentComponent = function ({
  cookieConsent,
  acceptCookieConsent
}) {
  const { t } = useTranslation();
  return cookieConsent !== true && <CookieConsent style={{
    background: '#373A40'
  }} disableButtonStyles buttonClasses='btn btn-primary btn-lg m-3' onAccept={acceptCookieConsent} cookieName='CookieConsent'>{t("HeresMyInfo does not share your data with anyone without your consent.")}{' '}{t("To use HeresMyInfo, you must agree to our")}{' '}
      <a href='/privacy' target='_blank' className='landing-highlight' style={{
      textDecoration: 'underline',
      fontWeight: 'bold'
    }}>{t("Privacy Policy")}</a>{t(", including cookie policy.")}</CookieConsent>;
};

const mapStateToProps = state => ({
  cookieConsent: state.settings.cookieConsent
});

const mapDispatchToProps = {
  acceptCookieConsent
};
export default connect(mapStateToProps, mapDispatchToProps)(CookieConsentComponent);